import { ComponentsProps } from '@material-ui/core/styles/props';

const props: ComponentsProps = {};

export default props;
